// USER ACTIONS (PREFIX WITH 'USER_')
// SYSTEM ACTIONS (NO PREFIX REQUIRED)
export const offerFilters = ['none', 'lease', 'finance'];

export const paymentTypes = {
  LEASE: 'LEASE',
  FINANCING: 'FINANCE'
};

export const optionTypes = {
  INCENTIVE: 'INCENTIVE',
  OFFER: 'OFFER'
};

// REDUX OUT OF THE BOX
export const REDUX_INIT = '@@INIT';

// ROUTING
export const BEFORE_ROUTE_CHANGE = 'BEFORE_ROUTE_CHANGE';
export const UPDATE_ROUTE_PARAMS = 'UPDATE_PUSHSTATE_PARAMS';
export const LOCATION_CHANGING = '@@router/LOCATION_CHANGE'
export const INVALID_MODELINE_ROUTE = 'INVALID_MODELINE_ROUTE';

// Linkouts
export const USER_EXTERNAL_LINK = 'USER_EXTERNAL_LINK';
export const USER_INTERNAL_LINK = 'USER_INTERNAL_LINK';


// API calls (ASYNC) SUCCEED, FAILED, COMPLETED
// GET ALL MODELLINES
export const GET_ALL_MODELLINES_SUCCEEDED = 'GET_ALL_MODELLINES_SUCCEEDED';
export const GET_ALL_MODELLINES_FAILED = 'GET_ALL_MODELLINES_FAILED';
export const GET_ALL_MODELLINES = 'GET_ALL_MODELLINES';
// GET MODEL TRIMS
export const GET_MODEL_TRIMS_SUCCEEDED = 'GET_MODEL_TRIMS_SUCCEEDED';
export const GET_MODEL_TRIMS_FAILED = 'GET_MODEL_TRIMS_FAILED';
export const GET_MODEL_TRIMS = 'GET_MODEL_TRIMS';

// PHASE-1 CHANGES GET BEST OFFERS
export const GET_BEST_OFFERS_SUCCEEDED = 'GET_BEST_OFFERS_SUCCEEDED';
export const GET_BEST_OFFERS_FAILED = 'GET_BEST_OFFERS_FAILED';
export const GET_BEST_OFFERS = 'GET_BEST_OFFERS';

// GET DMA NUMBER
export const GET_DMA_SUCCEEDED = 'GET_DMA_SUCCEEDED';
export const GET_DMA_FAILED = 'GET_DMA_FAILED';
export const GET_DMA = 'GET_DMA';
export const PRELOAD_DMA = 'PRELOAD_DMA';

// Non-Api (SYNC)
export const INIT_ESTIMATOR_APP = 'INIT_ESTIMATOR_APP';
export const LOAD_MODEL_VIEW = 'LOAD_MODEL_VIEW';
export const LOAD_TRIM_VIEW = 'LOAD_TRIM_VIEW';
export const ZIP_CODE_MODAL_OPENED = 'ZIP_CODE_MODAL_OPENED';
export const TOTAL_PERSONALIZED_AMOUNT_UPDATED = 'TOTAL_PERSONALIZED_AMOUNT_UPDATED';
export const OFFER_MODAL_OPENED = 'OFFER_MODAL_OPENED';
export const UPDATE_DMA = 'UPDATE_DMA';
export const UPDATE_TRIM_INCENTIVES = 'UPDATE_TRIM_INCENTIVES';

/* User Actions */

// Vehicle Grid/Trim interactions
export const USER_SELECTED_MODELLINE = 'USER_SELECTED_MODELLINE';
export const USER_OPENED_TRIM_SELECT = 'USER_OPENED_TRIM_SELECT';
export const USER_SELECTED_TRIM = 'USER_SELECTED_TRIM';

// Accordian slider interactions
export const USER_OPENED_ACCORDION = 'USER_OPENED_ACCORDION';
export const USER_CLOSED_ACCORDION = 'USER_CLOSED_ACCORDION';

// Credit Rating Selection interactions
export const USER_OPENED_CREDIT_RATING_SELECT = 'USER_OPENED_CREDIT_RATING_SELECT';
export const USER_UPDATED_CREDIT_RATING = 'USER_UPDATED_CREDIT_RATING';

// Personal Amounts Panel interactions
export const USER_UPDATED_DOWN_PAYMENT = 'USER_UPDATED_DOWN_PAYMENT';
export const USER_UPDATED_TRADE_IN_VALUE = 'USER_UPDATED_TRADE_IN_VALUE';
export const USER_UPDATED_BEST_OFFER_STATE = 'USER_UPDATED_BEST_OFFER_STATE';
export const APP_UPDATED_DOWN_PAYMENT = 'APP_UPDATED_DOWN_PAYMENT';

// Trim Summary box Selectors (Term, Mileage)
export const USER_OPENED_TERM_SELECT = 'USER_OPENED_TERM_SELECT';
export const USER_UPDATED_TERM = 'USER_UPDATED_TERM';
export const USER_OPENED_MILEAGE_SELECT = 'USER_OPENED_MILEAGE_SELECT';
export const USER_UPDATED_MILEAGE = 'USER_UPDATED_MILEAGE';

// Personalized amounts slider interactions
export const USER_CLOSED_PERSONALIZED_AMOUNT_SLIDER = 'USER_CLOSED_PERSONALIZED_AMOUNT_SLIDER';
export const USER_OPENED_PERSONALIZED_AMOUNT_SLIDER = 'USER_OPENED_PERSONALIZED_AMOUNT_SLIDER';

// Special Pricing Box interaction (MKS specific)
export const USER_CLICKED_OFFER_VIEW_DETAILS = 'USER_CLICKED_OFFER_VIEW_DETAILS';

// Zip code modal box interactions
export const USER_OPENED_ZIP_CODE_MODAL = 'USER_OPENED_ZIP_CODE_MODAL';
export const USER_UPDATED_ZIP_CODE = 'USER_UPDATED_ZIP_CODE';
export const USER_UPDATED_ZIP_CODE_ERROR = 'USER_UPDATED_ZIP_CODE_ERROR';
export const USER_CLOSED_ZIP_CODE_MODAL = 'USER_CLOSED_ZIP_CODE_MODAL';

// User interacted with Links
export const USER_CLICKED_BLACKBOX_LINK = 'USER_CLICKED_BLACKBOX_LINK';
export const USER_CLICKED_INTELLIPRICE_LINK = 'USER_CLICKED_INTELLIPRICE_LINK';

// User Interaction with the Trim View Selector
export const USER_OPENED_EDIT_TRIM_MODEL_CHOOSER = 'USER_OPENED_EDIT_TRIM_MODEL_CHOOSER';
export const USER_CLOSED_EDIT_TRIM_MODEL_CHOOSER = 'USER_CLOSED_EDIT_TRIM_MODEL_CHOOSER';

// On click of "RESET" button all personal options should be cleared and reset
export const USER_RESET_PERSONAL_OPTIONS = 'USER_RESET_PERSONAL_OPTIONS';

// User Amounts panel Slider
export const USER_CLOSED_USER_AMOUNTS_PANEL = 'USER_CLOSED_USER_AMOUNTS_PANEL';
export const USER_OPENED_USER_AMOUNTS_PANEL = 'USER_OPENED_USER_AMOUNTS_PANEL';

// Tabs select on Mobile view
export const USER_SELECTED_FINANCE_TAB = 'USER_SELECTED_FINANCE_TAB';
export const USER_SELECTED_LEASE_TAB = 'USER_SELECTED_LEASE_TAB';

// User interacted with offer details modal dialog
export const USER_OPENED_DETAILS_MODAL_DIALOG = 'USER_OPENED_DETAILS_MODAL_DIALOG';
export const USER_CLOSED_DETAILS_MODAL_DIALOG = 'USER_CLOSED_DETAILS_MODAL_DIALOG';

// On Credit Rating Change reset the Mileage and Terms
export const USER_RESET_TERM_MILEAGE = 'USER_RESET_TERM_MILEAGE';

// First Page load recorded for replacing Down payment with required down
export const INITIAL_DOWN_PAYMENT_LOADED = 'INITIAL_DOWN_PAYMENT_LOADED';
export const INITIAL_DOWN_PAYMENT_RESET = 'INITIAL_DOWN_PAYMENT_RESET';

export const USER_ADD_BODY_STYLE_FILTER = 'USER_ADD_BODY_STYLE_FILTER';
export const USER_REMOVE_BODY_STYLE_FILTER = 'USER_REMOVE_BODY_STYLE_FILTER';
export const SYSTEM_UPDATED_CASHBACK_AMOUNT = 'SYSTEM_UPDATED_CASHBACK_AMOUNT';

// New Constants for Dealer Select on Leads form
export const DEALER_QUERY_REQUEST = 'DEALER_QUERY_REQUEST';
export const DEALER_SET_ZIP_CODE = 'DEALER_SET_ZIP_CODE';
export const DEALER_OBJECT_UPDATE = 'DEALER_OBJECT_UPDATE';
export const DEALER_QUERY_SUBMITTING = 'DEALER_QUERY_SUBMITTING';
export const DEALER_QUERY_SUCCESS = 'DEALER_QUERY_SUCCESS';
export const DEALER_QUERY_ERROR = 'DEALER_QUERY_ERROR';
export const DEALER_OBJECT_RESET = 'DEALER_OBJECT_RESET';
export const DEALER_CLEAR_ERROR = 'DEALER_CLEAR_ERROR';
export const DEALER_RESET_STATE = 'DEALER_RESET_STATE';

// Nes Constants for Lead Submission
export const LEAD_SUBMISSION_REQUEST = 'LEAD_SUBMISSION_REQUEST';
export const LEAD_SUBMISSION_SUBMITTING = 'LEAD_SUBMISSION_SUBMITTING';
export const LEAD_SUBMISSION_SUCCESS = 'LEAD_SUBMISSION_SUCCESS';
export const LEAD_SUBMISSION_ERROR = 'LEAD_SUBMISSION_ERROR';
export const LEAD_SUBMISSION_RESET = 'LEAD_SUBMISSION_RESET';
export const UI_SET_SELECTED_DEALER = 'UI_SET_SELECTED_DEALER';



/** WEBPACK FOOTER **
 ** ./src/redux/constants.js
 **/